import { t } from 'i18next'
import { validationRules } from './constants'

const formValidation = {
  title: {
    required: t("VALIDATION_TITLE_REQUIRED"),
    pattern: {
      value: /^[^\s].*/,
      message: 'Cannot start with a space.'
    },
    minLength: {
      value: 3,
      message: t("VALIDATION_TITLE_MIN_LENGTH")
    },
    validate: value => {
      return value.trim() ? true : 'White spaces not allowed.'
    }
  },
  authorName: {
    required: t("VALIDATION_AUTHOR_REQUIRED"),
    pattern: {
      value: /^[^\s].*/,
      message: 'Cannot start with a space.'
    },
    minLength: {
      value: 3,
      message: t("VALIDATION_AUTHOR_MIN_LENGTH")
    },
    validate: value => {
      return value.trim() ? true : 'White spaces not allowed.'
    }
  },
  categoryId: {
    required: t("VALIDATION_SELECT_CATEGORY"),
    validate: value => {
      return value ? true : 'White spaces not allowed.'
    }
  },
  subCategoryId: {
    required:false,
    validate: value => {
      return value ? true : 'White spaces not allowed.'
    }
  },
}

export default formValidation
